/* assets/register-error-overwrite.js
   只在 /account/register：
   1) 在 h2.form__message（“Oops !”）後插入你要的兩行訊息（only "here" 連到 /account/login）
   2) 將原生錯誤清單「移除出 DOM」（不只是隱藏），就算主題重繪也持續清掉
*/
(function () {
  if (!/\/account\/register(?:[\/?#]|$)/i.test(location.pathname)) return;

  var MSG_ID   = 'nyEmailTakenMsg';

  function insertMessage() {
    var h2 = document.querySelector('h2.form__message');
    if (!h2) return false;

    var box = document.getElementById(MSG_ID);
    if (!box) {
      box = document.createElement('div');
      box.id = MSG_ID;
      box.style.margin = '10px 0';
      box.style.lineHeight = '1.6';
      box.innerHTML =
        '<div>This email address is already associated with an account.</div>' +
        '<div>Please log in <a href="/account/login" class="ny-reset-link">here</a> after get our approval.</div>';
      h2.insertAdjacentElement('afterend', box);
    } else {
      box.style.display = '';
      box.removeAttribute('aria-hidden');
    }
    return true;
  }

  // 強力清除：把原生錯誤清單直接 remove()
  function removeNativeLists() {
    // 盡量包含各主題：常見是 h2 後面的 <ul role="list"> 或 .errors 區塊
    var selectors = [
      'h2.form__message + ul',
      'h2.form__message + * ul',
      'ul[role="list"]',
      'ul.errors',
      '.errors ul',
      '.form__message ~ ul',
      '.customer ul[role="list"]'
    ];
    var removed = false;

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // 跳過我們插入的訊息區塊
        if (el.id === MSG_ID || el.closest('#' + MSG_ID)) return;
        try {
          el.parentNode && el.parentNode.removeChild(el);
          removed = true;
        } catch (e) {}
      });
    });

    // 有些主題會把 ul 外面再包一層容器（紅框），一起清掉
    var wrappers = [
      'h2.form__message + div',
      '.errors',
      '.form__message + .form__message',   // 某些主題把訊息又包一層
    ];
    wrappers.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (wrap) {
        if (wrap.id === MSG_ID || wrap.closest('#' + MSG_ID)) return;
        // 若這個 wrapper 裡面本來有我們要清的 ul，且已經變空，就把 wrapper 也移除
        if (!wrap.querySelector('ul, li')) return;
        try {
          wrap.parentNode && wrap.parentNode.removeChild(wrap);
          removed = true;
        } catch (e) {}
      });
    });

    return removed;
  }

  function run() {
    var ok = insertMessage();
    removeNativeLists();
    return ok;
  }

  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });

  // 再保險輪詢數秒，避免主題延後插入錯誤區塊
  var tries = 0, tm = setInterval(function () {
    if (run() || ++tries > 40) clearInterval(tm);
  }, 150);
})();
